import Reveal from "@/components/7fcc/Reveal";
import SectionHeader from "@/components/7fcc/SectionHeader";
import VslPlayer from "@/components/7fcc/VslPlayer";
import { VSL } from "@/data/content";

export default function VslSection() {
  return (
    <section id="vsl" className="relative bg-ink-900 px-6 py-16 md:py-24" data-testid="vsl-section">
      <div className="mx-auto max-w-[900px]">
        <SectionHeader center eyebrow={VSL.eyebrow} title={VSL.headline} support={VSL.support} testId="vsl-heading" />
        <Reveal delay={0.15} className="mt-10">
          <VslPlayer src={VSL.videoSrc} label={VSL.videoLabel} testId="vsl-video" />
        </Reveal>
        <Reveal delay={0.22}>
          <p className="mt-4 text-center text-sm text-fg-dim" data-testid="vsl-caption">
            {VSL.caption}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
